import { Center, Spinner, Text, VStack } from "@chakra-ui/react"
import React from "react"
import { useAllServicesQuery } from "../../graphql"
import { ServicesList } from "./ServicesList"

export const AllServices: React.FC = () => {
	const [{ data, fetching, error }] = useAllServicesQuery()

	return (
		<VStack w="full" maxW="2xl" align="stretch">
			{fetching && !data?.allServices ? (
				<Center w="full" py="4">
					<VStack w="full" color="grayscale.label">
						<Text fontSize="sm">Loading services</Text>
						<Spinner size="sm" />
					</VStack>
				</Center>
			) : error ? (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						{error.message.replace("[GraphQL] ", "")}
					</Text>
				</Center>
			) : data?.allServices && data.allServices.length ? (
				<VStack w="full" align="stretch">
					<Text>
						Showing {data.allServices.length || 0} service
						{(data.allServices.length || 0) > 1 ? "s" : ""}
					</Text>

					<ServicesList services={data.allServices} />

					{fetching && (
						<Center w="full" py="4">
							<VStack w="full" color="grayscale.label">
								<Text fontSize="sm">Loading more services</Text>
								<Spinner size="sm" />
							</VStack>
						</Center>
					)}
				</VStack>
			) : (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						Couldn&apos;t find any services.
					</Text>
				</Center>
			)}
		</VStack>
	)
}
